import { pageLayout } from "./page-layout";

export const pageMode = {
    ...pageLayout,
    mediumPage: 'medium-page',
    editPage: 'edit-page',
    createPage: 'create-page',
} as const;

export type TPageMode = (typeof pageMode)[keyof typeof pageMode];
